import { SiMeta, SiGoogle, SiTiktok } from '@icons-pack/react-simple-icons';
import type { IconType } from '@icons-pack/react-simple-icons';
import type { LeadSource } from '@troia-v3/types';
import { LEAD_SOURCE_LABELS } from '@troia-v3/types';

import type { IconName } from '../types';

export type LeadSourceCatalogEntry =
  | { kind: 'simple-icon'; icon: IconType;     label: string }
  | { kind: 'feather';     iconName: IconName; label: string };

/**
 * Mapeamento canônico `LeadSource → ícone + label`.
 *
 * Sources com brand reconhecível (Meta, Google, TikTok, LinkedIn): logo via
 * `@icons-pack/react-simple-icons`.
 *
 * Demais sources: ícone Feather semanticamente equivalente
 * (organic → globo, email → envelope, etc.).
 *
 * Cor é responsabilidade do consumer (passa via prop `color` ou herda
 * `currentColor`). Default deve ser roxo TROIA `#8b5cf6` ou `#7c3aed`.
 *
 * Adicionar novo source: editar `LEAD_SOURCES` em `@troia-v3/types/leads.ts`
 * (single source of truth) — TypeScript exigirá nova entry aqui também.
 */
export const LEAD_SOURCE_CATALOG: Record<LeadSource, LeadSourceCatalogEntry> = {
  meta:      { kind: 'simple-icon', icon: SiMeta,   label: LEAD_SOURCE_LABELS.meta },
  google:    { kind: 'simple-icon', icon: SiGoogle, label: LEAD_SOURCE_LABELS.google },
  tiktok:    { kind: 'simple-icon', icon: SiTiktok, label: LEAD_SOURCE_LABELS.tiktok },

  // SiLinkedin não existe no @icons-pack/react-simple-icons — fallback Feather
  linkedin:  { kind: 'feather', iconName: 'linkedin',      label: LEAD_SOURCE_LABELS.linkedin },
  microsoft: { kind: 'feather', iconName: 'monitor',       label: LEAD_SOURCE_LABELS.microsoft },
  organic:   { kind: 'feather', iconName: 'globe',         label: LEAD_SOURCE_LABELS.organic },
  referral:  { kind: 'feather', iconName: 'user-plus',     label: LEAD_SOURCE_LABELS.referral },
  email:     { kind: 'feather', iconName: 'mail',          label: LEAD_SOURCE_LABELS.email },
  offline:   { kind: 'feather', iconName: 'phone',         label: LEAD_SOURCE_LABELS.offline },
  partner:   { kind: 'feather', iconName: 'users',         label: LEAD_SOURCE_LABELS.partner },
  outbound:  { kind: 'feather', iconName: 'send',          label: LEAD_SOURCE_LABELS.outbound },
  direct:    { kind: 'feather', iconName: 'mouse-pointer', label: LEAD_SOURCE_LABELS.direct },
};
